// import { FOOTER } from './constants';
import HomeIcon from '../assets/images/footerHomeIcon2.svg';
import HomeLightIcon from '../assets/images/homeLight2.svg';
import DemoHomeIcon from '../assets/images/home-active.png';
import DemoHomeLightIcon from '../assets/images/home_light.png';
import ShopIcon from '../assets/images/shopping_cart.svg';
import ShopLightIcon from '../assets/images/shopping_cart2.svg';
import ServicesIcon from '../assets/images/footerServiceIcon2.svg';
import ServicesLightIcon from '../assets/images/servicesLight2.svg';
import CirclesIcon from '../assets/images/footerCircleIcon2.svg';
import CirclesLightIcon from '../assets/images/circlesLight2.svg';
import UtilitiesActiveIcon from '../assets/images/utilitiesActiveIcon.svg';
import UtilitiesInactiveIcon from '../assets/images/utilitiesInActiveIcon.svg';
import { mockTemplates } from '../features/dynamicRecords/mockTemplate';
import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';

const labelToIcons = {
  Home: {
    icon: DemoHomeIcon,
    lightIcon: DemoHomeLightIcon,
  },
  Shop: {
    icon: ShopIcon,
    lightIcon: ShopLightIcon,
  },
  Circles: {
    icon: CirclesIcon,
    lightIcon: CirclesLightIcon,
  },
  Records: {
    icon: ServicesIcon,
    lightIcon: ServicesLightIcon,
  },
  Utilities: {
    icon: UtilitiesActiveIcon,
    lightIcon: UtilitiesInactiveIcon,
  },
};

const get = () => {
  const { selectedLanguage } = useSelector((state) => state.app);
  const { templates } = useSelector((state) => state.templates);
  const [footerList, setFooterList] = useState([]);

  useEffect(() => {
    const FOOTER =
      templates?.texts?.[selectedLanguage]?.HEADER?.NAVIGATION?.FOOTER ||
      mockTemplates?.texts?.[selectedLanguage]?.HEADER?.NAVIGATION?.FOOTER ||
      [];

    const footerWithIcons = FOOTER.map((item) => {
      const label = item.label;
      const iconSet = labelToIcons[label] || {};
      return {
        ...item,
        icon: iconSet.icon || null,
        lightIcon: iconSet.lightIcon || null,
      };
    });

    setFooterList(footerWithIcons);
  }, [selectedLanguage, templates]);

  return footerList;
};

const footerIconGetter = { get };

export default footerIconGetter;
